// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__A1ms-","content":"Layout_content__V5Jc7"};